import moment from "moment"
import queryString from "query-string"
import * as React from "react"
import { Button, Modal } from "react-bootstrap"
import styled from "styled-components"
import { syncFavorites } from "../backendServices/FavoritesServices"
import { BackendServiceError } from "../backendServices/BackendServicesUtils"
import { CalendarEntry, findChatConversation, setMuteStatus } from "../backendServices/GraphQLServices"
import { doConnectAction, MakeConnectionResponse } from "../backendServices/SeriesOfTopicsUserServices"
import { EntityType, ModalType, ShareTargetType } from "../backendServices/Types"
import branding from "../branding/branding"
import { ChimeContext } from "../conference/context/ChimeContext"
import { useMeetingContext } from "../conference/context/MeetingContext"
import { RosterContext } from "../conference/context/RosterContext"
import { MeetingStatusCode } from "../conference/enums/MeetingStatusCode"
import { buildDetailLink } from "../contentArea/detailPages/DetailNavLink"
import { AppStateContextMethods, useAppState } from "../globalStates/AppState"
import { getIamPartOf } from "../globalStates/IAmPartOf"
import { User } from "../globalStates/LoggedInUser"
import { CalendarEntryModalViewMode } from "../ui/modals/CalendarEntryModal"
import {
    IconBlockContact,
    IconCalendarEntry,
    IconCamera,
    IconChat,
    IconClose,
    IconConnect,
    IconConnectWithdraw,
    IconDecline,
    IconDownloadVCard,
    IconFavorite,
    IconFavoriteFilled,
    IconPhone,
    IconRecommend,
    IconRemoveStaff,
    IconReport,
    VGIcon
} from "../ui/Icons"
import { useRecommendModal } from "../ui/modals/RecommendModal"
import ReportModal from "../ui/modals/ReportModal"
import { hasAccessToUser } from "../utils/UserUtils"
import { isExplorationOrPostEventPhase, isPostEventPhase } from "../utils/EventPhaseChecker"
import { setInitialStates } from "../utils/SayHello"
import { ChatConversationParam } from "./ChatPage"
import { useContactState } from "./ContactState"
import { saveVCard } from "./VCard"
import SayHelloModal from "../ui/modals/SayHelloModal"
import { useEffect } from "react"
import { FavoriteContextMethods } from "../globalStates/Favorites"
import { useGuestModal } from "../ui/modals/GuestModal"
import { MeetingInvitation } from "../conferenceV2/context/MeetingInvitation"
import { MeetingController } from "../conferenceV2/context/MeetingController"
import { InvitationType } from "../API"
import CalendarEntryModal2 from "../ui/modals/calendarEntry/CalendarEntryModal2"
import { trackTakeAction } from "../utils/GTMTracking"
import { capitalizeFirstLetter } from "../utils/StringUtils"

const MainModal = styled(Modal)`
    .modal-content {
        padding: 10px;
        border-radius: 5px;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
    }
    .modal-header {
        /* display: inline-flex;
        border-bottom: none; */
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        border: none;
        padding: 20px 0 20px 0;
    }

    .modal-body {
        font-family: ${branding.font1};
        font-weight: 400;
        font-size: 12px;
        line-height: 17px;
        display: flex;
        padding: 10px 20px;
        white-space: pre-line;
        word-break: break-word;
    }

    .modal-footer {
        justify-content: space-between;
        border: none;
    }

    .close {
        outline: 0;
        position: absolute;
        right: 20px;
        top: 15px;
        font-size: 46px;
        font-weight: 10;
        line-height: 1.66666667;
        color: #000;
        width: 30px;
        padding: 0 2px;
        background: none;
        border-style: none;
        margin-right: 1px;
        margin-top: -16px;
    }

    .btn-primary {
        display: inline-block;
        border: none;
        font-family: ${branding.font1};
        :focus {
            outline: none;
            cursor: pointer;
        }
    }

    .btn-secondary {
        display: inline-block;
        border: none;
        font-family: ${branding.font1};
        :focus {
            outline: none;
            cursor: pointer;
        }
    }
`
const Title = styled.div`
    width: auto;
    height: 20px;
    margin-left: 20px;
    margin-top: 15px;
    font-family: ${branding.font1};
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 20px;
`

const CancelButton = styled.div`
    display: block;
    width: 28%;
    height: 30px;
    color: ${branding.recommendModal.cancelBtnPrimaryTextColor ?? "#000"};
    background-color: transparent;
    border: 1px solid ${branding.recommendModal.cancelBtnPrimaryBorderColor}!important;
    border-radius: 5px;
    font-size: 12px;
    line-height: 17px;
    font-family: ${branding.font1};
    margin-right: 15px;

    :hover {
        background-color: ${branding.recommendModal.submitBtnPrimaryOnHoverBgColor} !important;
        color: ${branding.recommendModal.submitBtnPrimaryOnHoverTextColor} !important;
    }

    :focus {
        cursor: pointer;
        outline: none;
        border: none;
    }
`
const ConfirmButton = styled(Button)`
    display: block;
    width: 28%;
    height: 30px;
    color: ${branding.recommendModal.submitBtnPrimaryTextColor} !important;
    background-color: ${branding.recommendModal.submitBtnPrimaryBgColor}!important;
    border: 1px solid ${branding.recommendModal.submitBtnPrimaryBorderColor}!important;
    border-radius: 5px;
    font-size: 12px;
    line-height: 17px;
    font-family: ${branding.font1};

    :hover {
        background-color: ${branding.recommendModal.submitBtnPrimaryOnHoverBgColor} !important;
        color: ${branding.recommendModal.submitBtnPrimaryOnHoverTextColor} !important;
    }
`
const CloseButton = styled.div`
    position: absolute;
    right: 30px;
    top: 30px;
    cursor: pointer;
    svg {
        color: ${branding.mainInfoColor};
    }
`
const SubmitButtonContainer = styled.div`
    width: 100%;
    justify-content: flex-end;
    display: inline-flex;
    margin-bottom: 20px;
`

function getSayHelloTexts(status: string, isPersonTile?: boolean) {
    const conn = setInitialStates(status)
    switch (conn.messageType) {
        case "cancelRequestMessage":
            return {
                hint: branding.contactEntry.cancelRequestMessage,
                title: branding.contactEntry.cancelRequestTitle,
                icon: IconConnectWithdraw({
                    fill: isPersonTile
                        ? branding.contextMenuBranding.contextIconColorPersonTiles
                        : branding.sideIconBar.sideIconColorDark,
                    stroke: isPersonTile ? branding.sideIconBar.sideIconColorDark : "#fff"
                })
            }
        case "cancelConnectionMessage":
            return {
                hint: branding.contactEntry.cancelConnectionMessage,
                title: branding.contactEntry.disconnectTitle,
                icon: IconRemoveStaff({
                    fill: isPersonTile
                        ? branding.contextMenuBranding.contextIconColorPersonTiles
                        : branding.sideIconBar.sideIconColorDark
                })
            }
        case "ignoredMessage":
            return {
                hint: branding.contactEntry.ignoredMessage,
                title: branding.contactEntry.connectTitle,
                icon: IconConnect({
                    fill: isPersonTile
                        ? branding.contextMenuBranding.contextIconColorPersonTiles
                        : branding.sideIconBar.sideIconColorDark
                })
            }
        case "blockedMessage":
            return {
                hint: branding.contactEntry.ignoredMessage,
                title: branding.contactEntry.connectTitle,
                icon: IconConnect({
                    fill: isPersonTile
                        ? branding.contextMenuBranding.contextIconColorPersonTiles
                        : branding.sideIconBar.sideIconColorDark
                })
            }
        case "openRequestMessage":
            return {
                hint: branding.contactEntry.openRequestMessageHint,
                title: branding.contactEntry.openRequestMessage,
                icon: IconConnect({
                    fill: isPersonTile
                        ? branding.contextMenuBranding.contextIconColorPersonTiles
                        : branding.sideIconBar.sideIconColorDark
                })
            }
        case "sendRequestMessage":
            return {
                hint: branding.contactEntry.sendRequestMessage,
                title: branding.contactEntry.connectTitle,
                icon: IconConnect({
                    fill: isPersonTile
                        ? branding.contextMenuBranding.contextIconColorPersonTiles
                        : branding.sideIconBar.sideIconColorDark
                })
            }
        default:
            return { title: "test", hint: "" }
    }
}

function doVCard(person: any) {
    saveVCard([person])
}

export async function updateBlocked(loggedInUserId: any | undefined, person: any, contactState: any) {
    const isBlocking = contactState.getConnectionStatus(person.id) === "BLOCKING"
    const response = await doConnectAction({
        profileId: loggedInUserId!,
        targetProfileId: person.id,
        action: isBlocking ? "cancel" : "block",
        message: null
    })

    let conversation = await findChatConversation(loggedInUserId, person.id)
    if (conversation) {
        setMuteStatus(conversation.userConversationId, !isBlocking)
    }

    if ((response as BackendServiceError).httpStatus) {
        // TODO ERROR
    } else {
        let newStatus = (response as MakeConnectionResponse).content.profile.myConnectionStatus

        /**
         * GUIDE:4235: Fix for app break after unblocking a person.
         *
         * The code was implemented to set the person as UNRELEATED after unblocking, therefore
         * this person was removed from the list. See NetworkingPageContent.tsx line 810.
         *
         * And if the user clicks unblock, the person isn't present int the list and the app breaks
         *
         */

        if (newStatus === "UNRELATED") {
            newStatus = ""
        }

        person.myConnectionStatus = newStatus
        contactState.setConnectionStatus(person.id, newStatus)
    }
}

export const doCall = (
    personId: string,
    meeting: any,
    chime: ChimeContext,
    callback: (param: { modalType: ModalType }) => void
) => {
    const meetingParam = meeting.getCurrentMeetingParam()
    if (meetingParam) {
        meeting.sendInvite(personId, meetingParam)
    } else if (chime.getMeetingStatus().meetingStatusCode === MeetingStatusCode.Succeeded) callback({ modalType: "call" })
    else meeting.sendInvite(personId)
}

const doChat = (personId: string, appState: AppStateContextMethods) => {
    appState.setChatsSubtab(ChatConversationParam.privateConversationByOpponentId(personId))
}

const updateBookmarkedStatus = (
    loggedInUserId: any | undefined,
    person: any,
    favorites: FavoriteContextMethods,
    date: Date,
    callback: (param: { bookmarkChanged: boolean }) => void,
    sotUser?: boolean
) => {
    const userType = sotUser ? "sotuser" : "person"

    function syncFav(id: string, type: EntityType) {
        syncFavorites({
            profileId: loggedInUserId,
            body: {
                currentTime: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
                lastSyncTime: favorites.getLastSyncTime(),
                changedFavorites: [
                    {
                        id: id,
                        kind: type.toUpperCase(),
                        deleted: favorites.is(type, id) ? false : true,
                        lastModified: moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
                    }
                ]
            }
        })
            .then((resp) => {
                favorites.setLastSyncTime(new Date())
                callback({ bookmarkChanged: true })
            })
            .catch((e: { message: React.SetStateAction<string> }) => {
                // syncFavorites failed, logged in BackendServices
            })
    }

    if (loggedInUserId) {
        if (!favorites.is(userType, person.id)) {
            trackTakeAction(
                `Set Favorite ${capitalizeFirstLetter(userType)} ${person.firstName} ${person.lastName}`,
                "SetFavorite",
                capitalizeFirstLetter(userType)
            )
        }

        if (person.person && person.type === "speaker") {
            favorites.toggle("person", person.person)
        }
        favorites.toggle(userType, person.id)

        syncFav(person.id, "person")
        syncFav(person.id, "sotuser")
        syncFav(person.person, "person")

        favorites.triggerRefreshFavorites(person.id)
    }
}

export interface ConfirmCallProps {
    show: boolean
    onHide: () => void
    sotUserId: string
}

export const ConfirmCall: React.FC<ConfirmCallProps> = ({ show, onHide, sotUserId }) => {
    const meeting = useMeetingContext()
    const appState = useAppState()

    return (
        <MainModal show={show} onHide={onHide} backdrop="static" centered animation={false}>
            <Modal.Header>
                <Modal.Title style={{ display: "inline-flex" }}>
                    <Title>{branding.conferenceTexts.changingRoomConfirmationTitle}</Title>
                </Modal.Title>
                <CloseButton onClick={onHide}>
                    {IconClose({ fill: branding.recommendModal.closeIconColor, width: "15", height: "15" })}
                </CloseButton>
            </Modal.Header>
            <Modal.Body>{branding.conferenceTexts.changingRoomConfirmationText}</Modal.Body>
            <Modal.Footer>
                <SubmitButtonContainer>
                    <CancelButton onClick={onHide} className="d-flex align-items-center justify-content-center">
                        {branding.globalTexts.cancel}
                    </CancelButton>
                    <ConfirmButton
                        type="submit"
                        onClick={() => {
                            appState.setIsMyHandRaised(false)
                            meeting.sendInvite(sotUserId)
                            onHide()
                        }}
                        className="d-flex align-items-center justify-content-center"
                    >
                        {branding.conferenceTexts.changingRoomConfirmationAccept ?? branding.globalTexts.confirm}
                    </ConfirmButton>
                </SubmitButtonContainer>
            </Modal.Footer>
        </MainModal>
    )
}

export default ConfirmCall

export interface Action {
    disabled: boolean
    title: string
    hint: string
    icon: VGIcon
    onClick: () => void
}

export const chatAction = (
    connectionStatus: string,
    personId: string,
    appState: AppStateContextMethods,
    hideChat: boolean,
    disableUserButtons?: boolean,
    accessToUserGranted?: boolean,
    enableGuestModal?: Function,
    isPersonTile?: boolean
) => {
    const userButtonsDisabled = disableUserButtons !== undefined ? disableUserButtons : false
    return {
        disabled: userButtonsDisabled || connectionStatus === "BLOCKED" || connectionStatus === "BLOCKING",
        title: branding.contactEntry.sendMessageTitle,
        hint: branding.contactEntry.sendMessageHint,
        icon: IconChat({
            fill: isPersonTile ? branding.contextMenuBranding.contextIconColorPersonTiles : branding.sideIconBar.sideIconColorDark
        }),
        onClick: () => {
            if (accessToUserGranted) {
                doChat(personId, appState)
            } else {
                if (enableGuestModal) {
                    enableGuestModal()
                }
            }
        },
        hideOnMobile: true,
        hideOnDesktop: hideChat
    }
}

export const callAction = (
    connectionStatus: string,
    personId: string,
    meeting: any,
    chimeContext: ChimeContext,
    meetingInvitation: MeetingInvitation,
    rosterContext: RosterContext,
    callback: (param: { bookmarkChanged?: boolean; modalType?: ModalType }) => void,
    disableUserButtons?: boolean,
    accessToUserGranted?: boolean,
    enableGuestModal?: Function,
    isPersonTile?: boolean
) => {
    let userIsInMeeting = false
    const queryParams: any = queryString.parse(window.location.search)
    const userButtonsDisabled = disableUserButtons !== undefined ? disableUserButtons : false
    // Only calculate if the Menu is open,
    const roster = rosterContext.getRoster()
    for (let rosterKey in roster) {
        if (roster[rosterKey].id === personId) {
            userIsInMeeting = true
            break
        }
    }

    return {
        disabled:
            (isExplorationOrPostEventPhase && !(getIamPartOf(queryParams) === "onboarding")) ||
            userButtonsDisabled ||
            connectionStatus === "BLOCKED" ||
            connectionStatus === "BLOCKING" ||
            branding.contactEntry.disableVideoChatIcon ||
            (meeting.getCurrentMeetingParam() !== undefined && (rosterContext.hasMaxAttendees() || userIsInMeeting)),
        title: branding.contactEntry.startVideoCallTitle,
        hint: meeting.getCurrentMeetingParam()
            ? branding.contactEntry.inviteToCallHint
            : branding.contactEntry.startVideoCallHint,
        icon: IconCamera({
            fill: isPersonTile
                ? branding.contextMenuBranding.contextIconColorPersonTiles
                : branding.sideIconBar.sideIconColorDark,
            width: "23",
            height: "23"
        }),
        onClick: () => {
            if (accessToUserGranted) {
                doCall(personId, meeting, chimeContext, callback)
            } else {
                if (enableGuestModal) {
                    enableGuestModal()
                }
            }
        },
        hideOnMobile: true
    }
}

export const declineAction = (declineMeeting: () => void) => {
    return {
        disabled: false,
        title: branding.calendarEntryListView.declineButtonTitle,
        hint: branding.calendarEntryListView.declineButtonTitle,
        icon: IconClose({ fill: branding.sideIconBar.sideIconColorDark, width: "16", height: "16" }),
        onClick: declineMeeting
    }
}

export const createActions = (
    loggedInUser: User | undefined,
    person: any,
    favorites: FavoriteContextMethods,
    contactState: any,
    appState: AppStateContextMethods,
    meeting: any,
    chime: ChimeContext,
    meetingInvitation: MeetingInvitation,
    meetingController: MeetingController,
    hideReportButton: boolean,
    roster: RosterContext,
    isBookmarked: boolean,
    connectionStatus: string,
    callback: (param: { bookmarkChanged?: boolean; modalType?: ModalType }) => void,
    additionalActions?: Action[],
    disableUserButtons?: boolean,
    sotUser?: boolean,
    hideChat?: boolean,
    isPersonTile?: boolean,
    isDarkMode?: boolean
) => {
    const isBlocked = connectionStatus === "BLOCKED"
    const isBlocking = connectionStatus === "BLOCKING"
    const isConnected = connectionStatus === "CONNECTED"
    const date = new Date()
    const sayHello = getSayHelloTexts(connectionStatus, isPersonTile)
    const accessToUserGranted = hasAccessToUser(loggedInUser, person)

    function enableGuestModal() {
        callback({ modalType: "guest" })
    }

    const userButtonsDisabled = disableUserButtons !== undefined ? disableUserButtons : false

    const networkingFunctionsDisabled = !loggedInUser?.matchActive && connectionStatus === "UNRELATED"

    let result = [
        {
            // bookmark / favorite button
            disabled: isBlocked || isBlocking || branding.contactEntry.disableBookmarkIcon,
            title: isBookmarked ? branding.contactEntry.unbookmarkTitle : branding.contactEntry.bookmarkTitle,
            hint: isBookmarked ? branding.contactEntry.unbookmarkHint : branding.contactEntry.bookmarkHint,
            icon: isBookmarked
                ? IconFavoriteFilled({
                      fill: isPersonTile
                          ? branding.contextMenuBranding.contextIconColorPersonTiles
                          : branding.sideIconBar.sideIconColorDark,
                      width: "22",
                      height: "22"
                  })
                : IconFavorite({
                      fill: isPersonTile
                          ? branding.contextMenuBranding.contextIconColorPersonTiles
                          : branding.sideIconBar.sideIconColorDark,
                      stroke: isPersonTile
                          ? branding.contextMenuBranding.contextIconColorPersonTiles
                          : branding.sideIconBar.sideIconColorDark,
                      width: "22",
                      height: "22"
                  }),
            onClick: () => {
                if (accessToUserGranted) {
                    updateBookmarkedStatus(loggedInUser?.profileId, person, favorites, date, callback, sotUser)
                } else {
                    enableGuestModal()
                }
            },
            hideOnMobile: false
        },
        {
            disabled:
                userButtonsDisabled ||
                isBlocked ||
                isBlocking ||
                networkingFunctionsDisabled ||
                branding.contactEntry.disableConnectIcon,
            title: sayHello.title,
            hint: sayHello.hint,
            icon: sayHello.icon,
            onClick: () => {
                if (accessToUserGranted) {
                    callback({ modalType: "connect" })
                } else {
                    enableGuestModal()
                }
            },
            hideOnMobile: true
        },
        {
            disabled:
                userButtonsDisabled ||
                isBlocked ||
                isBlocking ||
                isPostEventPhase ||
                networkingFunctionsDisabled ||
                branding.contactEntry.disableMeetingIcon,
            title: branding.contactEntry.requestMeetingTitle,
            hint: branding.contactEntry.requestMeetingHint,
            icon: IconCalendarEntry({
                fill: isPersonTile
                    ? branding.contextMenuBranding.contextIconColorPersonTiles
                    : branding.sideIconBar.sideIconColorDark,
                stroke: branding.sideIconBar.sideIconColorDark
            }),
            onClick: () => {
                if (accessToUserGranted) {
                    callback({ modalType: "meeting" })
                } else {
                    enableGuestModal()
                }
            },
            hideOnMobile: false
        },
        chatAction(
            connectionStatus,
            person.id,
            appState,
            hideChat || false,
            userButtonsDisabled || networkingFunctionsDisabled,
            accessToUserGranted,
            enableGuestModal,
            isPersonTile
        ),
        callAction(
            connectionStatus,
            person.id,
            meeting,
            chime,
            meetingInvitation,
            roster,
            callback,
            userButtonsDisabled || networkingFunctionsDisabled,
            accessToUserGranted,
            enableGuestModal,
            isPersonTile
        ),
        {
            disabled: isBlocked || isBlocking || branding.contactEntry.disableShareIcon,
            title: branding.contactEntry.shareTitle,
            hint: branding.contactEntry.shareHint,
            icon: IconRecommend({
                fill: isPersonTile
                    ? branding.contextMenuBranding.contextIconColorPersonTiles
                    : branding.sideIconBar.sideIconColorDark
            }),
            onClick: () => {
                callback({ modalType: "share" })
            },
            hideOnMobile: false
        },
        {
            disabled: !isConnected || networkingFunctionsDisabled || branding.contactEntry.disableDownloadIcon,
            title: branding.contactEntry.downloadVCardTitle,
            hint: branding.contactEntry.downloadVCardHint,
            icon: IconDownloadVCard({
                fill: isPersonTile
                    ? branding.contextMenuBranding.contextIconColorPersonTiles
                    : branding.sideIconBar.sideIconColorDark,
                width: "21",
                height: "21"
            }),
            onClick: () => {
                if (accessToUserGranted) {
                    doVCard(person)
                } else {
                    enableGuestModal()
                }
            },
            hideOnMobile: true
        },
        {
            disabled: userButtonsDisabled || isBlocked || networkingFunctionsDisabled || branding.contactEntry.disableBlockIcon,
            title: isBlocking ? branding.contactEntry.unblockPersonTitle : branding.contactEntry.blockPersonTitle,
            hint: isBlocking ? branding.contactEntry.unblockPersonHint : branding.contactEntry.blockPersonHint,
            icon: isBlocking
                ? IconDecline({
                      fill: isPersonTile
                          ? branding.contextMenuBranding.contextIconColorPersonTiles
                          : branding.sideIconBar.sideIconColorDark,
                      stroke: isPersonTile ? branding.sideIconBar.sideIconColorDark : "#fff"
                  })
                : IconBlockContact({
                      fill: isPersonTile
                          ? branding.contextMenuBranding.contextIconColorPersonTiles
                          : branding.sideIconBar.sideIconColorDark
                  }),
            onClick: () => {
                if (accessToUserGranted) {
                    updateBlocked(loggedInUser?.profileId, person, contactState)
                } else {
                    enableGuestModal()
                }
            },
            hideOnMobile: false
        },
        {
            disabled: isBlocking || networkingFunctionsDisabled || branding.contactEntry.disableReportIcon,
            title: branding.communicationArea.reportText,
            hint: branding.communicationArea.reportHint,
            icon: IconReport({
                fill: isPersonTile
                    ? branding.contextMenuBranding.contextIconColorPersonTiles
                    : branding.sideIconBar.sideIconColorDark,
                stroke: isPersonTile ? branding.sideIconBar.sideIconColorDark : "#fff"
            }),
            onClick: () => {
                if (accessToUserGranted) {
                    callback({ modalType: "report" })
                } else {
                    enableGuestModal()
                }
            }
        }
    ]
    if (additionalActions) {
        result = result.concat(additionalActions)
    }

    const queryParams: any = queryString.parse(window.location.search)

    if (branding.configuration.useConferenceRoomV2) {
        result.splice(
            4,
            1,
            {
                disabled:
                    (isExplorationOrPostEventPhase && !(getIamPartOf(queryParams) === "onboarding")) ||
                    userButtonsDisabled ||
                    connectionStatus === "BLOCKED" ||
                    connectionStatus === "BLOCKING" ||
                    branding.contactEntry.disableVideoChatIcon ||
                    (meeting.getCurrentMeetingParam() !== undefined && meetingController.getHasMaxAttendees()),
                title: "Video call",
                hint: "Video call",
                icon: IconCamera({
                    fill: isPersonTile
                        ? branding.contextMenuBranding.contextIconColorPersonTiles
                        : branding.sideIconBar.sideIconColorDark,
                    width: "23",
                    height: "23"
                }),
                onClick: () => {
                    if (accessToUserGranted) {
                        meetingInvitation.sendInvite(person.id, InvitationType.VIDEO)
                    } else {
                        if (enableGuestModal) {
                            enableGuestModal()
                        }
                    }
                }
            },
            {
                disabled:
                    (isExplorationOrPostEventPhase && !(getIamPartOf(queryParams) === "onboarding")) ||
                    userButtonsDisabled ||
                    connectionStatus === "BLOCKED" ||
                    connectionStatus === "BLOCKING" ||
                    branding.contactEntry.disableVideoChatIcon ||
                    (meeting.getCurrentMeetingParam() !== undefined && meetingController.getHasMaxAttendees()),
                title: "Audio call",
                hint: "Audio call",
                icon: IconPhone({
                    fill: isPersonTile
                        ? branding.contextMenuBranding.contextIconColorPersonTiles
                        : branding.sideIconBar.sideIconColorDark,
                    width: "23",
                    height: "23"
                }),
                onClick: () => {
                    if (accessToUserGranted) {
                        meetingInvitation.sendInvite(person.id, InvitationType.AUDIO)
                    } else {
                        if (enableGuestModal) {
                            enableGuestModal()
                        }
                    }
                }
            }
        ) // remove the old call button and replace it with two new buttons

        // if (hideReportButton) result.splice(result.length - 1, 1) // remove report button
    }

    return result
}
export interface CommunicationModalsProps {
    show: ModalType
    contact: any
    calendarEntry?: CalendarEntry
    onHide: () => void
    onWithdrawRequest?: (contactId: string) => void
    removePosition?: boolean // remove absolute position when say hello is called inside meeting
}

export const CommunicationModals: React.FC<CommunicationModalsProps> = ({
    contact,
    show,
    calendarEntry,
    onHide,
    onWithdrawRequest,
    removePosition
}) => {
    const contactState = useContactState()
    const { showRecommendModal, RecommendModal } = useRecommendModal(onHide)
    const { showGuestModal, GuestModal } = useGuestModal(onHide)

    useEffect(() => {
        switch (show) {
            case "share":
                showRecommendModal(
                    ShareTargetType.SOTUSER,
                    contact.id,
                    `${contact.firstName} ${contact.lastName}`,
                    buildDetailLink(
                        contact.person ?? contact.id,
                        `/person/${contact.firstName}_${contact.lastName}`,
                        contact.person || contact.eventDates ? "person" : "user"
                    )
                )
                break
            case "guest":
                showGuestModal()
                break
        }
        // eslint-disable-next-line
    }, [show])

    switch (show) {
        case "connect":
            return (
                // because of a bug, we use the function component here and not the custom-hook useSayHelloModal()
                <SayHelloModal
                    contact={contact}
                    targetId={contact.id}
                    handleClose={onHide}
                    removePosition={removePosition}
                    setSayHelloResponseStatus={(connectStatus) => {
                        if (connectStatus === "UNRELATED" && onWithdrawRequest) {
                            onWithdrawRequest(contact.id)
                        }
                        contactState.setConnectionStatus(contact.id, connectStatus)
                    }}
                />
            )
        case "meeting":
            return (
                <CalendarEntryModal2
                    calendarEntry={calendarEntry}
                    viewMode={calendarEntry ? CalendarEntryModalViewMode.VIEW : CalendarEntryModalViewMode.CREATE}
                    sotUser={contact ? [contact!] : undefined}
                    close={onHide}
                />
            )
        case "call":
            return <ConfirmCall show={true} onHide={onHide} sotUserId={contact.id} />
        case "share": {
            return <RecommendModal />
        }
        case "report": {
            return <ReportModal show={true} onHide={onHide} userToReportId={contact.id} />
        }
        case "guest": {
            return <GuestModal />
        }
    }
    return null
}
